const SEND_INFO = 'index/SEND_INFO' as const;
const SET_SEND_INFO = 'index/SET_USER_INFO' as const;

export const getSendInfo = () => ({
  type: SEND_INFO,
});

export const setSendInfo = (state: SendState) => ({
  type: SET_SEND_INFO,
  payload: state,
});

type SendAction = ReturnType<typeof getSendInfo> | ReturnType<typeof setSendInfo>;

// 이 리덕스 모듈에서 관리 할 상태의 타입을 선언합니다
export type SendState = {
  from: string | `0x${string}`;
  to: string | `0x${string}`;
  value: string;
};
// 초기상태를 선언합니다.
const initialState: SendState = {
  from: '',
  to: '',
  value: ''
};

// 리듀서를 작성합니다.
// 리듀서에서는 state 와 함수의 반환값이 일치하도록 작성하세요.
// 액션에서는 우리가 방금 만든 CounterAction 을 타입으로 설정합니다.
function sender(state: SendState = initialState, action: SendAction): any {
  switch (action.type) {
    case SEND_INFO:
      return { ...state };
    case SET_SEND_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default sender;
